import GatsbyPageContext from "@contexts/GatsbyPageContext";
import React, { useContext } from "react";
import styled from "styled-components";

const UnstyledAnchor = styled.a`
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  font-stretch: inherit;
  font-style: inherit;
  line-height: inherit;
  text-decoration: underline;
`;

const UnclickableAnchor = styled(UnstyledAnchor)`
  text-decoration: inherit !important;
  cursor: inherit;

  :hover {
    opacity: inherit !important;
  }
`;

const Anchor = ({ href, ...props }) => {
	const { target = "_self" } = useContext(GatsbyPageContext) || {};
	if (href?.startsWith("#")) {
		const name = href.substring(1);
		return <UnclickableAnchor name={name} {...props} />;
	}

	return <UnstyledAnchor href={href} target={target} {...props} />;
};

export default Anchor;
